import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { waLink } from "@/lib/whatsapp";
import { setSeo, resetSeo } from "@/lib/seo";
import { Clock, User, MessageCircle, ArrowLeft, Loader2 } from "lucide-react";

export default function BlogPost() {
  const { slug } = useParams();
  const { settings } = useApp();
  const [b, setB] = useState(null);
  useEffect(() => { window.scrollTo(0, 0); api.get(`/blogs/${slug}`).then((r) => setB(r.data)); }, [slug]);

  useEffect(() => {
    if (b) setSeo({
      title: b.seo_title || b.title, description: b.seo_description || b.excerpt, image: b.image,
      jsonLd: { "@context": "https://schema.org", "@type": "Article", headline: b.title, image: b.image,
        author: { "@type": "Person", name: b.author }, articleSection: b.category, description: b.excerpt },
    });
    return () => resetSeo();
  }, [b]);

  if (!b) return <div className="flex justify-center py-40"><Loader2 className="w-8 h-8 animate-spin text-forest" /></div>;

  return (
    <article className="max-w-3xl mx-auto px-4 py-8 lg:py-12">
      <Link to="/blog" className="inline-flex items-center gap-1.5 text-forest hover:text-terracotta mb-6"><ArrowLeft className="w-4 h-4" /> Back to Blog</Link>
      <span className="text-xs bg-mustard/25 text-brown px-3 py-1 rounded-full font-500">{b.category}</span>
      <h1 className="font-heading text-4xl lg:text-5xl text-forest tracking-tight mt-4 leading-[1.1]">{b.title}</h1>
      <div className="flex items-center gap-4 mt-4 text-sm text-muted-foreground">
        <span className="inline-flex items-center gap-1.5"><User className="w-4 h-4" />{b.author}</span>
        <span className="inline-flex items-center gap-1.5"><Clock className="w-4 h-4" />{b.read} min read</span>
        <span>{b.views} views</span>
      </div>
      <div className="aspect-[16/9] rounded-[28px] overflow-hidden bg-sand my-8 soft-shadow"><img src={b.image} alt={b.title} className="w-full h-full object-cover" /></div>
      <div className="prose max-w-none text-brown/85 leading-relaxed [&>h3]:font-heading [&>h3]:text-2xl [&>h3]:text-forest [&>h3]:mt-6 [&>h3]:mb-2 [&>p]:mb-4" dangerouslySetInnerHTML={{ __html: b.content }} />
      <div className="mt-10 bg-sand rounded-2xl p-6 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="font-heading text-xl text-forest">Have questions about your wellness journey?</p>
        <a href={waLink(settings.whatsapp_number, `Hi LIVENEAT Organic, I just read "${b.title}" and have a question.`)} target="_blank" rel="noreferrer"
          className="inline-flex items-center gap-2 bg-[#25D366] text-white rounded-full h-11 px-6 font-500 shrink-0" data-testid="blog-wa-btn"><MessageCircle className="w-4 h-4" /> Ask on WhatsApp</a>
      </div>
    </article>
  );
}
